const ConsoleHelper = (data) => {
    if (import.meta.env.NODE_ENV === 'production') return
    //eslint-disable-next-line
    console.log(data)
  }
export default ConsoleHelper